var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{staticClass:"custom-card",style:(_vm.customStyle),attrs:{"headStyle":_vm.headStyle,"title":_vm.title,"bordered":_vm.bordered}},[_c('div',{staticClass:"custom-card-container",style:(_vm.customCardStyle)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }